// Permission-to-route mapping for ui.finance.cg
// Derived from MENU_STRUCTURE as the single source of truth

import { MENU_STRUCTURE } from './menuStructure';

// Build a flat { permission: [paths] } map from MENU_STRUCTURE
function buildRoutePermissionMap() {
  const map = {};

  function walk(items, inheritedPermissions) {
    items.forEach(item => {
      const perms = item.permissions || inheritedPermissions || [];

      // Collect the item's own path
      if (item.path && perms.length > 0) {
        perms.forEach(perm => {
          if (!map[perm]) map[perm] = [];
          if (!map[perm].includes(item.path)) {
            map[perm].push(item.path);
          }
        });
      }

      // Collect subRoutes (inherit parent permissions)
      if (item.subRoutes) {
        item.subRoutes.forEach(sub => {
          if (sub.path && perms.length > 0) {
            perms.forEach(perm => {
              if (!map[perm]) map[perm] = [];
              if (!map[perm].includes(sub.path)) {
                map[perm].push(sub.path);
              }
            });
          }
        });
      }

      // Collect routes array
      if (item.routes) {
        item.routes.forEach(route => {
          if (route.path && perms.length > 0) {
            perms.forEach(perm => {
              if (!map[perm]) map[perm] = [];
              if (!map[perm].includes(route.path)) {
                map[perm].push(route.path);
              }
            });
          }
        });
      }

      // Recurse into children (they have their own permissions)
      if (item.children) {
        walk(item.children, null);
      }
    });
  }

  walk(MENU_STRUCTURE, null);
  return map;
}

// Lazily computed route-permission map
let _routePermissionMap = null;
function getRoutePermissionMap() {
  if (!_routePermissionMap) {
    _routePermissionMap = buildRoutePermissionMap();
  }
  return _routePermissionMap;
}

// Helper function to check if user has permission for a route
export const hasRoutePermission = (userPermissions, routePath) => {
  if (!userPermissions || !userPermissions.length) return false;

  const routeMap = getRoutePermissionMap();

  // Strip dynamic params (e.g. /edit/:id → /edit) for matching
  const normalizedPath = routePath.replace(/\/:[^/]+/g, '');

  for (const [permission, routes] of Object.entries(routeMap)) {
    console.log(permission, routes);
    for (const route of routes) {
      const normalizedRoute = route.replace(/\/:[^/]+/g, '');
      if (normalizedRoute === normalizedPath) {
        return userPermissions.includes(permission);
      }
    }
  }

  // If route is not in permission map, deny access
  return false;
};

export const filterMenuByPermissions = (userPermissions = []) => {

  const hasAccess = (menu) => {
    // No permission field or empty permission array
    if (!menu.permissions || menu.permissions.length === 0) {
      return true;
    }

    // User must have at least one permission
    return menu.permissions.some(permission =>
      userPermissions.includes(permission)
    );
  };

  const filterMenuItems = (menuItems) => {
    return menuItems.reduce((result, menu) => {

      // Filter children first
      const filteredChildren = menu.children
        ? filterMenuItems(menu.children)
        : [];

      const selfAccessible = hasAccess(menu);

      // Keep menu if:
      // - itself accessible
      // - OR has accessible children
      const shouldShow =
        selfAccessible || filteredChildren.length > 0;

      if (!shouldShow) {
        return result;
      }

      result.push({
        ...menu,
        ...(menu.children && { children: filteredChildren })
      });

      return result;

    }, []);
  };

  return filterMenuItems(MENU_STRUCTURE);
};
